// @flow

import { connect } from 'react-redux';

import * as Profile from 'app/entities/Profile';
import Dismiss from 'app/viewport/components/TopBar/Dismiss';

import { type Dispatch } from 'app/common/types';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onDismiss: (trackingKey, profileId) => {
    // TODO: We have `acknowledgeNotification` and
    // `acknowledgeHelp` which both do the same thing
    // and will become problematic here. We need to
    // combine them into one thing.
    dispatch(Profile.actions.acknowledgeNotification(trackingKey, profileId));
  },
});

export default connect(null, mapDispatchToProps)(Dismiss);
